
export class FormaCobro{

    id: number
    nombre: string


    constructor() {
      this.id = 0
      this.nombre = ''

    }

   }
